const twoFiguresDisplay = (value: number) => value.toString().padStart(2, '0')

export const formatSecondsToDigitDisplay = (seconds: number) => {
  const displayedHours = Math.floor(seconds / 3600)
  const displayedMinutes = Math.floor((seconds % 3600) / 60)
  const displayedSeconds = twoFiguresDisplay(Math.floor(seconds % 60))

  return displayedHours > 0
    ? `${displayedHours}:${twoFiguresDisplay(displayedMinutes)}:${displayedSeconds}`
    : `${displayedMinutes}:${displayedSeconds}`
}
